import { render, staticRenderFns } from "./basicFrame.vue?vue&type=template&id=03b9359c&scoped=true&"
import script from "./basicFrame.vue?vue&type=script&lang=js&"
export * from "./basicFrame.vue?vue&type=script&lang=js&"
import style0 from "./basicFrame.vue?vue&type=style&index=0&id=03b9359c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9359c",
  null
  
)

export default component.exports